import zipObject from "lodash/zipObject";
import { type Observable, combineLatest, map } from "rxjs";
import { SubjectMap } from "./SubjectMap";

export function fromSubjectMap<T, S>(subjectMap: SubjectMap<T, S>): Observable<T> {
  return combineLatest(Object.values(subjectMap)).pipe(
    map((values) => zipObject(Object.keys(subjectMap), values) as T)
  );
}
